import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"overflow":"hidden","width":"560px"} }
const _hoisted_2 = { class: "field-group q-mt-sm" }
const _hoisted_3 = { class: "field-group__row no-wrap items-baseline justify-between" }
const _hoisted_4 = { class: "bold-name q-mr-xs" }
const _hoisted_5 = {
  key: 0,
  class: "required-asterisk"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "field-group q-mt-sm" }
const _hoisted_8 = { class: "field-group__row no-wrap items-baseline justify-between" }
const _hoisted_9 = { class: "bold-name q-mr-xs" }
const _hoisted_10 = {
  key: 0,
  class: "required-asterisk"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "field-group q-mt-sm" }
const _hoisted_13 = { class: "field-group__row no-wrap items-baseline justify-between" }
const _hoisted_14 = { class: "bold-name q-mr-xs" }
const _hoisted_15 = {
  key: 0,
  class: "required-asterisk"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "field-group q-mt-sm" }
const _hoisted_18 = { class: "field-group__row no-wrap items-baseline justify-between" }
const _hoisted_19 = { class: "bold-name q-mr-xs" }
const _hoisted_20 = {
  key: 0,
  class: "required-asterisk"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "field-group q-mt-sm" }
const _hoisted_23 = { class: "field-group__row no-wrap items-baseline justify-between" }
const _hoisted_24 = { class: "bold-name q-mr-xs" }
const _hoisted_25 = {
  key: 0,
  class: "required-asterisk"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "field-group q-mt-sm" }
const _hoisted_28 = { class: "field-group__row no-wrap justify-between" }
const _hoisted_29 = { class: "bold-name q-mr-xs" }
const _hoisted_30 = { class: "field-group q-mt-sm" }
const _hoisted_31 = { class: "bold-name q-mr-xs q-mt-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_native_input = _resolveComponent("native-input")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t('payment_type')), 1),
          (_ctx.theModel.paymentType == null || _ctx.theModel.paymentType === undefined)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, ":"))
        ]),
        _createVNode(_component_q_select, {
          flat: "",
          modelValue: _ctx.theModel.paymentType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel.paymentType) = $event)),
          style: {"min-width":"150px","padding":"0 !important"},
          class: "thin-input",
          "dropdown-icon": "expand_more",
          "fill-input": "",
          "bottom-slots": false,
          disable: _ctx.incomingOnly,
          dense: "",
          outlined: "",
          "input-debounce": "500",
          "emit-value": "",
          "map-options": "",
          "option-label": "Name",
          "option-value": "Id",
          ref: "from_select",
          options: _ctx.typeOptions
        }, null, 8, ["modelValue", "disable", "options"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.$t('amount')), 1),
          (Number(_ctx.theModel.paymentAmount) <= 0 || isNaN(Number(_ctx.theModel.paymentAmount)))
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "*"))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, ":"))
        ]),
        _createVNode(_component_native_input, {
          ref: "amount_input",
          style: {"min-width":"150px"},
          modelValue: _ctx.theModel.paymentAmount,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.theModel.paymentAmount) = $event)),
          "input-type": "number",
          "edit-on-click": true,
          "show-border": true,
          "min-number-value": 0
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.$t('number')), 1),
          (!String(_ctx.theModel.paymentNumber ?? '').trim())
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "*"))
            : (_openBlock(), _createElementBlock("span", _hoisted_16, ":"))
        ]),
        _createVNode(_component_native_input, {
          style: {"min-width":"150px"},
          ref: "number_input",
          "show-border": true,
          "edit-on-click": true,
          modelValue: _ctx.theModel.paymentNumber,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.theModel.paymentNumber) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createTextVNode(_toDisplayString(_ctx.$t('payment_date')), 1),
          (!_ctx.theModel.paymentDate)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "*"))
            : (_openBlock(), _createElementBlock("span", _hoisted_21, ":"))
        ]),
        _createVNode(_component_VueDatePicker, {
          utc: "preserve",
          timezone: "Europe/Moscow",
          locale: _ctx.$i18n.locale,
          style: 'width: 150px; min-width: 150px; max-width: 150px;',
          teleport: true,
          modelValue: _ctx.theModel.paymentDate,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.theModel.paymentDate) = $event)),
          "enable-time-picker": false,
          clearable: false,
          required: true,
          format: _ctx.formatDate,
          "text-input": _ctx.textInputOptions
        }, null, 8, ["locale", "modelValue", "format", "text-input"])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createTextVNode(_toDisplayString(_ctx.$t('currency')), 1),
          (!String(_ctx.theModel.currencyName ?? '').trim())
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "*"))
            : (_openBlock(), _createElementBlock("span", _hoisted_26, ":"))
        ]),
        _createVNode(_component_native_input, {
          style: {"min-width":"150px"},
          ref: "currency_name_input",
          "show-border": true,
          "edit-on-click": true,
          modelValue: _ctx.theModel.currencyName,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.theModel.currencyName) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('currency_rate')) + ": ", 1),
        _createVNode(_component_native_input, {
          style: {"min-width":"150px"},
          ref: "currency_input",
          modelValue: _ctx.theModel.paymentCurrency,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.theModel.paymentCurrency) = $event)),
          "input-type": "number",
          "edit-on-click": true,
          "show-border": true,
          "min-number-value": 0
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('payment_comment')) + ": ", 1),
      _createVNode(_component_native_input, {
        style: {"max-width":"100%","min-width":"100%"},
        ref: "comment_input",
        modelValue: _ctx.theModel.paymentNote,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.theModel.paymentNote) = $event)),
        "edit-on-click": true,
        "show-border": true
      }, null, 8, ["modelValue"])
    ])
  ]))
}